import { useMsal } from "@azure/msal-react";
import {
    Grid,
    Typography,
    Button,
    Paper,
    TextField,
    CircularProgress,
    Table, TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Link,
    Accordion,
    AccordionSummary
} from "@material-ui/core";
import { Delete, Error, Cancel, CheckCircle, AssignmentTurnedIn } from "@material-ui/icons";
import ForumIcon from '@material-ui/icons/Forum';
import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useStyles } from "./geraeteManagementStyles";
import {
    selectEditMode, selectMessstelleDaten, selectDokumente,
    addDokument, getDokument, deleteDokument, selectDokumentLoading,
    selectSelectedAktiverMesspunkt, emptyAktiverMesspunkt, selectEinzelDokumentLoading
} from "./geraeteManagementSlice";
import { selectLoadingKommunikation, selectBetriebsereignisListe } from "../betriebsereignisse/betriebsereignisseSlice";
import { globalStyles } from "../../assets/globalStyles";
import { nsTSToUTCStringWithoutNS, nsTSToLocalStringWithoutNS } from '../../utils/utils';
import { selectDate } from "../../features/konfiguration/konfigurationSlice";
import { isAuthorized, rollen } from "../../utils/auth/authConfig";
import { selectMessstellenLoadingLookup, getMessstellenLookup, getMessstellenForLookup, selectMessstellenDictionary } from '../../features/messstellenLookup/messstellenLookupSlice';


export const GeraetestatusAnhang: React.FC = () => {
    const dispatch = useAppDispatch();

    const { instance } = useMsal();
    const rollenObj = rollen;

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };

    useEffect(() => {
        dispatch(getMessstellenForLookup());
    }, [instance]);

    const [openFileUploadDialog, setOpenFileUploadDialog] = React.useState(false);
    const [fileDesc, setFileDesc] = React.useState("");
    const [selectedFile, setSelectedFile] = React.useState<File | null>(null);

    const loadingKommunikation = useAppSelector(selectLoadingKommunikation);
    const betriebsereignisListe = useAppSelector(selectBetriebsereignisListe);

    const selectedAktiverMesspunkt = useAppSelector(selectSelectedAktiverMesspunkt);
    const dokumente = useAppSelector(selectDokumente);
    const messstelleDaten = useAppSelector(selectMessstelleDaten);
    const dokumentLoading = useAppSelector(selectDokumentLoading);
    const einzelDokumentLoading = useAppSelector(selectEinzelDokumentLoading);
    const editMode = useAppSelector(selectEditMode);

    const messstellenDict = useAppSelector(selectMessstellenDictionary);
    const messstellenLoadingLookup = useAppSelector(selectMessstellenLoadingLookup);

    const isUTC = useAppSelector(selectDate);


    const selectFile = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event && event.target && event.target.files) {
            setSelectedFile(event.target.files[0]);
            setFileDesc(event.target.files[0].name);
        }
    }


const regEx = /^[a-zA-Z0-9äöüÄÖÜß\s\\.\\-\\(\\)_]{1,50}$/;
const getFileName = (name: string) => {
    if (regEx.test(name)) {
        setFileDesc(name)
        return name;
    } else {
        alert(`${name} is not a valid name!`)
    }
} 
    const uploadSelectedFile = () => {
        if (selectedFile) {
            setOpenFileUploadDialog(false);
            getFileName(fileDesc);
            dispatch(addDokument(selectedAktiverMesspunkt.name, selectedFile, fileDesc));
            setSelectedFile(null);
            setFileDesc("");
        }
    }

    const getIconForStateValue = (value: number) => {
        switch (value) {
            case 0:
                return (<CheckCircle style={{ color: "green" }} />)
            case 1:
                return (<Error style={{ color: "green" }} />)
            case 2:
                return (<Cancel className={classes.redSignalColor} />)
            default: return "";
        }
    };

    return (
        <React.Fragment>
            {(selectedAktiverMesspunkt != emptyAktiverMesspunkt) ?
                <Grid container item md={12} spacing={2} style={{ paddingLeft: "16px", paddingRight: "5px", marginTop: "10px" }} >
                    <Grid item md={6}>
                        <Paper>
                            <Grid item container md={12}>
                                <Accordion style={{ height: "100%", width: "100%", marginBottom: "-5px" }}>
                                    <AccordionSummary>
                                        <Typography className={classes.tableHeadline} variant="h6" style={{ marginBottom: "8px" }} >Gerätestatus</Typography>
                                    </AccordionSummary>
                                    <Grid style={{ minHeight: "115px" }} />
                                </Accordion>
                            </Grid>
                            {loadingKommunikation && messstellenLoadingLookup ?
                                (
                                    <TableContainer className={classes.heightScrolledTableBottom}>
                                        <Table stickyHeader style={{ overflow: "hidden" }}>
                                            <TableHead>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", textAlign: "center" }}><CircularProgress style={{ padding: "5px" }} /></TableCell>
                                            </TableHead>
                                        </Table>
                                    </TableContainer>
                                )
                                : (
                                    <TableContainer >
                                        <Table stickyHeader size="small" style={{ marginBottom: "50px" }}>
                                            <TableHead>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }} >Zustand</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", paddingRight: "0px" }}>Ereignis</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }} ></TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Umspannwerk</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Schaltfeld</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Messstelle</TableCell>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Beschreibung</TableCell>
                                                {/* <TableCell>Aktion</TableCell> */}
                                            </TableHead>
                                            <TableBody>
                                                {betriebsereignisListe.filter((e) => e.messstelle == messstelleDaten.name || e.messstelle == null).map((be, index) => (
                                                    <TableRow hover={true}
                                                     key={index}>
                                                         <TableCell>{getIconForStateValue(be.status)}</TableCell>
                                                        <TableCell style={{ maxWidth: "10px", width: "10px", paddingRight: "0px" }}>{be.typ ? (<AssignmentTurnedIn color="primary">Datenvollständigkeit</AssignmentTurnedIn>) : (<ForumIcon color="primary" >Kommunikation</ForumIcon>)}</TableCell>
                                                        <TableCell align="left" style={{ paddingLeft: "0px" }}>{be.typ ? "Datenvollständigkeit" : "Kommunikation"}</TableCell>
                                                        <TableCell>{getMessstellenLookup(messstellenDict, be.messstelle, "umspannwerk")}</TableCell>
                                                        <TableCell>{getMessstellenLookup(messstellenDict, be.messstelle, "schaltfeld")}</TableCell>
                                                        <TableCell>{be.messstelle}</TableCell>
                                                        <TableCell>{be.typ ? "Start der Datenvollständigkeit für Datenklasse " : ""}{be.beschreibung + ": " + (isUTC ? nsTSToUTCStringWithoutNS(be.zeit) : nsTSToLocalStringWithoutNS(be.zeit))}</TableCell> 
                                                        {/* <TableCell><Button color="secondary" onClick={() => linkToDetails(be.messstelle, be.zeit)}
                                                    >zur Detailansicht</Button></TableCell> */}
                                                    </TableRow>
                                                 ))} 
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                )}
                        </Paper>
                    </Grid>
                    <Grid item md={6}>
                        <Paper>
                            <Grid item container md={12}>
                                <Accordion style={{ height: "100%", width: "100%", marginBottom: "-5px" }}>
                                    <AccordionSummary>
                                        <Typography className={classes.tableHeadline} variant="h6" style={{ marginBottom: "8px" }} >Anhänge der Messstelle</Typography>
                                    </AccordionSummary>
                                    <Grid style={{ minHeight: "115px" }} />
                                </Accordion>
                            </Grid>
                             {dokumentLoading ?
                                (
                                    <TableContainer className={classes.heightScrolledTableBottom}>
                                        <Table stickyHeader style={{ overflow: "hidden" }}>
                                            <TableHead>
                                                <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", textAlign: "center" }}><CircularProgress style={{ padding: "5px" }} /></TableCell>
                                            </TableHead>
                                        </Table>
                                    </TableContainer>
                                )
                                : (
                                     
                                    <TableContainer className={classes.heightScrolledTable} >
                                        <Table stickyHeader size="small" style={{ marginBottom: "50px" }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Name</TableCell>
                                                    <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Beschreibung</TableCell>
                                                    <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Einstelldatum</TableCell>
                                                    <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600" }}>Aktion</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {dokumente.length == 0 ? <TableRow><TableCell colSpan={3}>Keine Anhänge</TableCell></TableRow> : dokumente.map((e, i) => (
                                                    <TableRow key={i}>
                                                        <TableCell><Link href="#" target="_blank" rel="noopener" onClick={(ev: React.MouseEvent) => { ev.preventDefault(); dispatch(getDokument(e)); }}>{e.name}</Link></TableCell>
                                                        <TableCell>{e.beschreibung}</TableCell>
                                                        <TableCell>{new Date(e.erstelldatum).toLocaleString()}</TableCell>
                                                        {editMode ?
                                                            <TableCell>
                                                                {isAuthorized([rollenObj.admin, rollenObj.betrieb]) ?
                                                                    <Button onClick={() => dispatch(deleteDokument(e))}>
                                                                        <Delete />
                                                                    </Button>
                                                                    : ""}
                                                            </TableCell>
                                                            : <TableCell />}
                                                    </TableRow>
                                                ))}
                                                {einzelDokumentLoading ? <TableRow><TableCell className={classes.tableHeadlineSub} style={{ backgroundColor: "white", fontWeight: "600", textAlign: "center" }}><CircularProgress style={{ padding: "5px" }} /></TableCell></TableRow> : ""}
                                                {editMode ?
                                                    <TableRow>
                                                        {isAuthorized([rollenObj.admin, rollenObj.betrieb]) ?
                                                            <TableCell colSpan={3}>
                                                                <Button data-cy="anhang-hinzufuegen-button" variant="contained" color="secondary" onClick={() => setOpenFileUploadDialog(true)}>Anhang hinzufügen</Button>
                                                                <Dialog
                                                                    data-cy="anhang-dialog"
                                                                    open={openFileUploadDialog}
                                                                    onClose={() => setOpenFileUploadDialog(false)}
                                                                >
                                                                    <DialogTitle>Anhang hinzufügen</DialogTitle>
                                                                    <DialogContent>
                                                                        <DialogContentText>
                                                                            Bitte wählen Sie die hochzuladende Datei aus (max. 6 MB) und geben optional eine Beschreibung ein.
                                                                        </DialogContentText>
                                                                        <Button variant="contained" component="label">Datei auswählen<input type="file" hidden onChange={(event) => selectFile(event)} /></Button><br />
                                                                        <TextField variant="outlined" id="fileDesc" label="Beschreibung" value={fileDesc} onChange={(ev) => setFileDesc(ev.target.value)} style={{ marginTop: "15px" }} />
                                                                    </DialogContent>
                                                                    <DialogActions>
                                                                        <Button
                                                                            data-cy="anhang-dialog-abbrechen-button"
                                                                            color="secondary"
                                                                            variant="contained"
                                                                            onClick={() => setOpenFileUploadDialog(false)}
                                                                            className={classes.cancleDeleteButton}
                                                                        >
                                                                            Abbrechen
                                                                        </Button>
                                                                        <Button
                                                                            data-cy="anhang-dialog-hinzufuegen-button"
                                                                            color="secondary"
                                                                            variant="contained"
                                                                            disabled={!selectedFile}
                                                                            onClick={() => uploadSelectedFile()}
                                                                            style={{ minWidth: "120px", minHeight: "36px" }}
                                                                        >
                                                                            {dokumentLoading ? <CircularProgress size="20px" style={{ color: "black" }} /> : "Hinzufügen"}
                                                                        </Button>
                                                                    </DialogActions>
                                                                </Dialog>
                                                            </TableCell>
                                                            : ""}
                                                    </TableRow>
                                                    : ""}
                                                    
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                 )} 

                        </Paper>
                    </Grid>

                </Grid>
                : ""}
        </React.Fragment>
    );
}